module.exports = __webpack_public_path__ + "3ba54d6e.png";